export default __webpack_public_path__ + "static/media/Bison-Bold(PersonalUse).586948d0.ttf";